var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4409 25.9147H18.5922H17.2865H17.0045V19.4108H19.1316C19.671 19.4108 19.9898 18.7978 19.671 18.3565L15.5333 12.6311C15.2697 12.2633 14.7242 12.2633 14.4606 12.6311L10.3228 18.3565C10.0041 18.7978 10.3167 19.4108 10.8623 19.4108H12.9894V25.9147H12.7074H11.4017H5.78055C2.56232 25.7369 0 22.7271 0 19.466C0 17.2163 1.21986 15.2547 3.0282 14.1942C2.86269 13.7467 2.77687 13.2686 2.77687 12.766C2.77687 10.4672 4.63425 8.60984 6.93298 8.60984C7.42951 8.60984 7.90764 8.69566 8.35513 8.86117C9.68533 6.04139 12.5541 4.08594 15.8888 4.08594C20.2043 4.09207 23.7597 7.39611 24.1643 11.6074C27.4806 12.1775 30 15.2486 30 18.7243C30 22.439 27.1067 25.6572 23.4409 25.9147Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.4ab42672.svg";
export { ForwardRef as ReactComponent };